import React from 'react';
import { useTranslation } from 'react-i18next';

const ConfirmationModal = ({ isOpen, onClose, onConfirm, title, message, confirmText, cancelText }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="tw-fixed tw-inset-0 tw-z-50 tw-flex tw-items-center tw-justify-center">
      {/* Backdrop */}
      <div 
        className="tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-50"
        onClick={onClose}
      ></div>
      
      {/* Modal */}
      <div className="tw-relative tw-bg-white tw-rounded-lg tw-p-6 tw-max-w-md tw-w-full tw-mx-4 tw-z-10">
        <div className="tw-flex tw-justify-between tw-items-center tw-mb-4">
          <h3 className="tw-text-xl tw-font-semibold">
            {title || t('common.confirm')}
          </h3>
          <button 
            onClick={onClose}
            className="tw-text-gray-500 hover:tw-text-gray-700 tw-text-2xl"
          >
            &times;
          </button>
        </div>
        
        <div className="tw-mb-6">
          <p className="tw-text-gray-700">{message}</p>
        </div>
        
        <div className="tw-flex tw-justify-end tw-space-x-3">
          <button
            type="button"
            onClick={onClose}
            className="tw-px-4 tw-py-2 tw-bg-gray-200 tw-rounded-md hover:tw-bg-gray-300 tw-transition-colors tw-duration-200"
          >
            {cancelText || t('common.cancel')}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="tw-px-4 tw-py-2 tw-bg-red-600 tw-text-white tw-rounded-md hover:tw-bg-red-700 tw-transition-colors tw-duration-200"
          >
            {confirmText || t('common.delete')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal; 